import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

import UserSearch from '@/shared/components/input/UserSearch';

import messages from '../hrmMessages';
import { FaUndo } from 'react-icons/fa';

export const defaultFilters = {
  employeeId: undefined,
  employeeProfile: undefined,
};

class EmployeeRelationMatrixFilters extends Component {
  constructor(props) {
    super(props);
    this.state = { hasFilters: this.computeHasFilters(props.filters) };
  }

  computeHasFilters = filters => filters.employeeId || filters.employeeProfile;

  filterChanged = filter => {
    const { filters, onFilterChange } = this.props;
    const newFilters = { ...filters, ...filter };
    const hasFilters = this.computeHasFilters(newFilters);

    if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
      onFilterChange(newFilters);
    }

    this.setState({ hasFilters });
  };

  resetFilters = () => {
    this.filterChanged({ ...defaultFilters });
  };

  render() {
    const { filters, columns, intl } = this.props;
    const { hasFilters } = this.state;

    return (
      <div>
        <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <UserSearch
                emptyLabel="All employees"
                onChange={v => this.filterChanged({ employeeId: v?.id })}
                value={filters.employeeId}
              />
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <select
                className="form-control"
                value={'' + filters.employeeProfile}
                onChange={e => this.filterChanged({ employeeProfile: e.target.value })}
              >
                <option value="">{intl.formatMessage(messages.AllEmployeeRoles)}</option>
                {columns.map(c => (
                  <option key={c.id} value={c.id}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
        {hasFilters && (
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <button
                type="button"
                className="btn btn-default btn-reset"
                onClick={() => this.resetFilters()}
              >
                <FaUndo className="react-icon" />
                &nbsp;
                <FormattedMessage {...messages.ResetFilters} />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

EmployeeRelationMatrixFilters.propTypes = {
  intl: intlShape.isRequired,
  filters: PropTypes.shape({
    employeeId: PropTypes.string,
    employeeProfile: PropTypes.string,
  }),
  onFilterChange: PropTypes.func.isRequired,
};

EmployeeRelationMatrixFilters.defaultProps = {
  filters: { ...defaultFilters },
};
export default injectIntl(EmployeeRelationMatrixFilters);
